export const isDevEnvironment = (): boolean =>
  import.meta.env.VITE_APP_ENV === 'dev';

export const isLocalEnvironment = (): boolean =>
  import.meta.env.VITE_APP_ENV === 'local';

export const isStageEnvironment = (): boolean =>
  import.meta.env.VITE_APP_ENV === 'stage';

export const isProdEnvironment = (): boolean =>
  import.meta.env.VITE_APP_ENV === 'prod';
